export default {"gitHash":"f3a29327b3c3be442d601fd3b8aefa00c5d07152","gitHashShort":"f3a2932","time":1650145313913,"platform":"linux","arch":"x64"};